import { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useObjectContext } from '../hooks/useObjectContext';

interface ObjectControlsProps {
  children: ReactNode;
}

export function ObjectControls({ children }: ObjectControlsProps) {
  const { regionTargets } = useObjectContext();

  if (!regionTargets.controls) {
    return null;
  }

  return createPortal(children, regionTargets.controls);
}
